import {
  BriefDeliverableStatusEnum,
  UploaderType,
} from "@entities/brief/lib/constants";

export const getTaskStatusLabel = (
  status?: BriefDeliverableStatusEnum,
  approvalPendingOn?: UploaderType
): string => {
  if (!status) return "Pending";

  const isInReview =
    approvalPendingOn === UploaderType.Brand &&
    status === BriefDeliverableStatusEnum.PendingApproval;
  if (isInReview) {
    return "In Review";
  }
  if (status === BriefDeliverableStatusEnum.EditsRequested) {
    return "Changes Requested";
  }

  const isNeedsApproval =
    status !== BriefDeliverableStatusEnum.Pending &&
    status !== BriefDeliverableStatusEnum.Completed &&
    status !== BriefDeliverableStatusEnum.Approved &&
    !isInReview;

  if (isNeedsApproval) {
    return "Needs Approval";
  }

  return `${status}`;
};

export const getLatestTaskStatusLabel = (
  stageName: string,
  status?: BriefDeliverableStatusEnum,
  approvalPendingOn?: UploaderType
): string => {
  if (!status) return `${stageName} Pending`;

  const isInReview = approvalPendingOn === UploaderType.Brand;
  if (isInReview) {
    return `${stageName}: In Review`;
  }
  if (status === BriefDeliverableStatusEnum.EditsRequested) {
    return `${stageName}: Changes Requested`;
  }

  const isNeedsApproval =
    status !== BriefDeliverableStatusEnum.Pending &&
    status !== BriefDeliverableStatusEnum.Completed &&
    status !== BriefDeliverableStatusEnum.Approved &&
    !isInReview;

  if (isNeedsApproval) {
    return `${stageName}: Needs Approval`;
  }

  return `${stageName}: ${status}`;
};

export const getTaskStatusColorClass = (
  styles: Record<string, string>,
  status?: BriefDeliverableStatusEnum,
  approvalPendingOn?: UploaderType
): string => {
  if (!status) return styles.taskStatusPending;

  const isInReview =
    approvalPendingOn === UploaderType.Brand &&
    status === BriefDeliverableStatusEnum.PendingApproval;
  if (isInReview) {
    return styles.taskStatusInReview;
  }

  const isNeedsApproval =
    status !== BriefDeliverableStatusEnum.Pending &&
    status !== BriefDeliverableStatusEnum.Completed &&
    status !== BriefDeliverableStatusEnum.Approved &&
    status !== BriefDeliverableStatusEnum.EditsRequested &&
    !isInReview;

  if (isNeedsApproval) {
    return styles.taskStatusNeedsApproval;
  }

  const statusMap: Record<string, string> = {
    [BriefDeliverableStatusEnum.Completed]: styles.taskStatusCompleted,
    [BriefDeliverableStatusEnum.Approved]: styles.taskStatusCompleted,
    [BriefDeliverableStatusEnum.PendingApproval]: styles.taskStatusPendingApproval,
    [BriefDeliverableStatusEnum.EditsRequested]: styles.taskStatusEditsRequested,
    [BriefDeliverableStatusEnum.Pending]: styles.taskStatusPending,
  };
  return statusMap[status] || styles.taskStatusPending;
};
